<script setup>
defineProps({
  open: {
    type: Boolean,
    required: true,
  },
})

const emit = defineEmits(['close', 'delete'])

function handleClose() {
  emit('close')
}
</script>

<template>
  <teleport to="body">
    <transition
      enter-active-class="transition ease-out duration-200"
      enter-from-class="transform opacity-0"
      enter-to-class="transform opacity-100"
      leave-active-class="transition ease-in duration-150"
      leave-from-class="transform opacity-100"
      leave-to-class="transform opacity-0"
    >
      <div
        v-if="open"
        class="fixed inset-0 z-[100] flex items-center justify-center p-4"
        @click.self="handleClose"
      >
        <div class="inset-0 z-[-1] bg-black opacity-40 w-full h-full absolute top-0 left-0" />
        <div class="flex w-full max-w-[590px] max-h-[480px] flex-col overflow-hidden rounded-2xl bg-white">
          <div class="flex items-center justify-between px-6 py-4">
            <h2 class="font-inter text-xl font-bold leading-none tracking-[0.005em]">
              {{ $t('newBradley.deleteModal.title') }}
            </h2>
            <button
              class="rounded-lg p-2 transition-colors hover:bg-gray-100"
              @click="handleClose"
            >
              <i class="pi pi-times text-lg text-gray-600" />
            </button>
          </div>

          <p class="px-6 text-[#334155]">
            {{ $t('newBradley.deleteModal.description') }}
          </p>

          <div class="px-6 py-4 flex justify-end gap-3">
            <button
              class="py-2 px-3 text-sm bg-[#EF4444] text-white font-semibold rounded-lg transition-colors cursor-pointer"
              @click="emit('delete')"
            >
              {{ $t('newBradley.deleteModal.delete') }}
            </button>
            <button
              class="py-2 px-3 bg-dss-primary-500 hover:bg-dss-primary-600 font-hellix font-medium text-sm leading-none text-white rounded-lg transition-colors cursor-pointer"
              @click="handleClose"
            >
              {{ $t('newBradley.deleteModal.cancel') }}
            </button>
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>
